import { z } from 'zod/mini';
import { OrderLineRuleSchema, OrderLineSchema } from '~/validation/api/packageSessionResponse';
import OptionRuleInterface from './optionRuleInterface';

/*
 * If the source options are selected (quantity > 0):
 * - Set recommended to true
 * Else
 * - Set recommended to false
 */
class Recommendation implements OptionRuleInterface {
  // eslint-disable-next-line class-methods-use-this
  apply(
    orderLines: z.infer<typeof OrderLineSchema>[],
    sourceOrderLines: z.infer<typeof OrderLineSchema>[],
    targetOrderLines: z.infer<typeof OrderLineSchema>[],
    _rule: z.infer<typeof OrderLineRuleSchema>,
    _pax: number,
  ) {
    return orderLines.map((orderLine) => {
      const orderLineClone = { ...orderLine };

      const isTargetOrderLine = targetOrderLines
        .some((targetOrderLine) => targetOrderLine.id === orderLine.id);

      if (!isTargetOrderLine) {
        return orderLineClone;
      }

      const hasSelectedSourceOrderLine = sourceOrderLines
        .some((sourceOrderLine) => sourceOrderLine.quantities.some((quantity) => quantity > 0));

      if (!hasSelectedSourceOrderLine) {
        orderLineClone.recommended = false;
        return orderLineClone;
      }

      orderLineClone.recommended = true;
      return orderLineClone;
    });
  }
}

export default Recommendation;
